export default __webpack_public_path__ + "static/media/Cargo Services.64997cef.jpg";